import cn from 'classnames'

import { ChatBoxVariant } from '../../types/ChatBoxTypes'

export const containerStyles = `
    flex flex-col items-center gap-3
    w-full pt-1
`
export const containerFocusedStyles = `
    h-[100px]
    border-[2px]
`

export const generateChatVariantContainerFocusedStyles = `
    py-[11px] pr-[11px] pl-[19px]
    border-[2px]
`

export const commonTextFieldWithButtonContainerStyles = `
    flex justify-between gap-4
    w-full py-3 pr-3 pl-[20px]
    border
    rounded-[16px]
    shadow-sm
    transition-colors
    duration-300
`

export const getTextFieldWithButtonContainerStyles = (
   variant: ChatBoxVariant
): string => {
   switch (variant) {
      case 'GENERATE': {
         return cn(
            commonTextFieldWithButtonContainerStyles,
            `items-center max-h-[128px]`
         )
      }

      case 'DEFAULT':
      default: {
         return cn(
            commonTextFieldWithButtonContainerStyles,
            `items-start max-h-[100px]`
         )
      }
   }
}

export const textAreaContainerStyles = `
    w-full
`

export const textAreaInputStyles = `
    !px-[0px] 
    !border-[0px] 
    shadow-none
    !ring-[0px]
`

export const commonTextAreaStyles = `
    min-h-[24px]
    mr-0
    resize-none
    scrollbar
`

export const getTextAreaStyles = (variant: ChatBoxVariant): string => {
   switch (variant) {
      case 'GENERATE': {
         return cn(commonTextAreaStyles, `max-h-[calc(128px_-_32px)]`)
      }

      case 'DEFAULT':
      default: {
         return cn(commonTextAreaStyles, `max-h-[calc(100px_-_40px)]`)
      }
   }
}

export const commonDescriptionTextStyles = `
    text-xs-regular
`

export const linkTextStyles = `
    underline
    cursor-pointer
`

export const sendIconStyles = `
    transition-transform duration-300
`

export const iconButtonContainerStyles = `
    w-[40px] h-[40px]
    transition-colors duration-150
`
